module.exports = __webpack_public_path__ + "static/media/home_icon_hover.4a9d3e26.png";